"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paneFilterOptionSchema = void 0;
const zod_1 = require("zod");
const lingo2_models_1 = require("lingo2-models");
exports.paneFilterOptionSchema = zod_1.z.object({
  baseRoute: zod_1.z.nativeEnum(lingo2_models_1.EContentPanelRoute).optional(),
  contentMode: zod_1.z.nativeEnum(lingo2_models_1.EContentModeType).optional(),
  contentOrder: zod_1.z.nativeEnum(lingo2_models_1.EContentOrder).optional(),
  levels: zod_1.z.record(zod_1.z.number(), zod_1.z.array(zod_1.z.string())).optional(),
  languageCodes: zod_1.z.array(zod_1.z.string()).optional(),
  term: zod_1.z.string().optional(),
  item: zod_1.z.string().optional(),
  currency: zod_1.z.string().toLowerCase(),
  subjectsMap: zod_1.z.array(zod_1.z.coerce.number()).optional()
});
